import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/**
 * Component for showing an item in the page menu.
 *
 * @extends React.Component
 */
class PageMenuItem extends Component {
  /** @inheritdoc */
  render() {
    return (
      <Link className="list-group-item list-group-item-action active" id="list-1-list" data-toggle="list" role="tab" aria-controls="home" to={this.props.href}>{this.props.label}</Link>
    );
  }
}

export default PageMenuItem;



// WEBPACK FOOTER //
// ./src/components/PageMenuItem/index.js